import {
  ArrowDownOnSquareIcon,
  ArrowTrendingUpIcon,
  ArrowUpOnSquareStackIcon,
  BanknotesIcon,
  BellAlertIcon,
  ChartBarIcon,
  ChatBubbleBottomCenterTextIcon,
  ChatBubbleLeftRightIcon,
  Cog6ToothIcon,
  CogIcon,
  CurrencyDollarIcon,
  DevicePhoneMobileIcon,
  DocumentTextIcon,
  ExclamationTriangleIcon,
  IdentificationIcon,
  KeyIcon,
  ListBulletIcon,
  NoSymbolIcon,
  PhotoIcon,
  PlayIcon,
  ShoppingBagIcon,
  SparklesIcon,
  TicketIcon,
  UserGroupIcon,
  UsersIcon,
  VideoCameraIcon,
  ViewColumnsIcon,
  WalletIcon,
  WindowIcon,
} from '@heroicons/react/24/outline';

export const Dashboard = () => [
  {
    id: 'dashboard-member',
    label: 'Member',
    icon: <UserGroupIcon className='w-5 h-5' />,
    to: '/dashboard',
    subs: [],
    act: 'R',
  },
  {
    id: 'dashboard-profit',
    label: 'Profit',
    icon: <ChartBarIcon className='w-5 h-5' />,
    to: '/dashboard-profit',
    subs: [],
    act: 'R',
  },
  {
    id: 'dashboard-trx',
    label: 'Transaksi',
    icon: <DocumentTextIcon className='w-5 h-5' />,
    to: '/dashboard-trx',
    subs: [],
    act: 'R',
  },
];

export const Member = () => [
  {
    id: 'customers',
    icon: <UsersIcon className='w-5 h-5' />,
    label: 'Customer',
    to: '/customers',
    subs: [],
    act: 'R,U',
  },
  {
    id: 'partners',
    icon: <UserGroupIcon className='w-5 h-5' />,
    label: 'Partner',
    to: '/partners',
    subs: [],
    act: 'C,R,U,D',
  },
  {
    id: 'setting-spv',
    icon: <CogIcon className='w-5 h-5' />,
    label: 'SPV',
    to: '/setting-spv',
    subs: [],
    act: 'C,R,U',
  },
  {
    id: 'verification-customer',
    icon: <IdentificationIcon className='w-5 h-5' />,
    label: 'Verifikasi Customer',
    to: '/verification-customer',
    subs: [],
    act: 'C,R,U',
  },
  {
    id: 'request-limit',
    icon: <ArrowDownOnSquareIcon className='w-5 h-5' />,
    label: 'Pengajuan Limit',
    to: '/request-limit',
    subs: [],
    act: 'R,U',
  },
  {
    id: 'monitoring-customer-limit',
    icon: <ViewColumnsIcon className='w-5 h-5' />,
    label: 'Monitoring Limit',
    to: '/monitoring-customer-limit',
    subs: [],
    act: 'R,E',
  },
  {
    id: 'monitoring-customer',
    icon: <UserGroupIcon className='w-5 h-5' />,
    label: 'Riwayat PIN',
    subs: [
      {
        id: 'monitoring-customer-history-pin',
        label: 'Ganti PIN',
        to: '/monitoring-customer-history-pin',
        subs: [],
        act: 'R',
        icon: <UserGroupIcon className='w-5 h-5' />,
      },
      {
        id: 'monitoring-customer-wrong-pin',
        label: 'Salah PIN',
        to: '/monitoring-customer-wrong-pin',
        subs: [],
        act: 'R,D',
        icon: <UserGroupIcon className='w-5 h-5' />,
      },
    ],
  },
];

export const CustomerService = (unread = {}) => {
  const { total = 0, customer = 0, guest = 0 } = unread;

  return [
    {
      id: 'message',
      icon: <ChatBubbleLeftRightIcon className='w-5 h-5' />,
      label: 'Chat',
      subs: [
        {
          id: 'message-customer',
          icon: <ChatBubbleBottomCenterTextIcon className='w-5 h-5' />,
          label: 'Customer',
          to: '/chat',
          subs: [],
          act: 'R',
          unreadCustomer: customer,
        },
        {
          id: 'message-guest',
          icon: <ChatBubbleBottomCenterTextIcon className='w-5 h-5' />,
          label: 'Guest',
          to: '/chat-guest',
          subs: [],
          act: 'R',
          unreadGuest: guest,
        },
      ],
      act: 'R',
      unreadTotal: total,
    },
    {
      id: 'feedback',
      icon: <ChatBubbleBottomCenterTextIcon className='w-5 h-5' />,
      label: 'Kritik & Saran',
      to: '/feedback',
      subs: [],
      act: 'R',
    },
    {
      id: 'notification',
      icon: <BellAlertIcon className='w-5 h-5' />,
      label: 'Notifikasi',
      to: '/notifications',
      subs: [],
      act: 'C,R,D',
    },
  ];
};

export const PPOB_Trx = () => [
  {
    id: 'ppob-transaction',
    icon: <WalletIcon className='w-5 h-5' />,
    label: 'PPOB',
    to: '/ppob-transaction',
    subs: [],
    act: 'R,U',
  },
  {
    id: 'report-transaction-inbox',
    icon: <ViewColumnsIcon className='w-5 h-5' />,
    label: 'Inbox',
    to: '/report-transaction-inbox',
    subs: [],
    act: 'R,E',
  },
  {
    id: 'product-inject-inbox',
    icon: <ChatBubbleBottomCenterTextIcon className='w-5 h-5' />,
    label: 'Inbox Inject',
    to: '/product-inject-inbox',
    subs: [],
    act: 'R,D',
  },
  {
    id: 'report-innet-trx',
    icon: <ViewColumnsIcon className='w-5 h-5' />,
    label: 'Innet',
    to: '/report-innet-trx',
    subs: [],
    act: 'R,E',
  },
  {
    id: 'report-transfer-uang',
    icon: <ExclamationTriangleIcon className='w-5 h-5' />,
    label: 'Transfer Uang',
    to: '/report-transfer-uang',
    subs: [],
    act: 'R,E',
  },
  {
    id: 'report-transfer-saldo',
    icon: <ExclamationTriangleIcon className='w-5 h-5' />,
    label: 'Transfer Saldo',
    to: '/report-transfer-saldo',
    subs: [],
    act: 'R,E',
  },
];

export const Wallet = () => [
  {
    id: 'deposit',
    icon: <WalletIcon className='w-5 h-5' />,
    label: 'Deposit',
    to: '/deposit',
    subs: [],
    act: 'R,U',
  },
  {
    id: 'method',
    icon: <WalletIcon className='w-5 h-5' />,
    label: 'Metode Pembayaran',
    subs: [
      {
        id: 'deposit-method',
        icon: <WalletIcon className='w-5 h-5' />,
        label: 'Deposit',
        to: '/payment-method-deposit',
        subs: [],
        act: 'C,R,U,D',
      },
      {
        id: 'payment-method-ppob',
        icon: <WalletIcon className='w-5 h-5' />,
        label: 'PPOB',
        to: '/payment-method-ppob',
        subs: [],
        act: 'C,R,U,D',
      },
      {
        id: 'payment-method-webtopup',
        icon: <WalletIcon className='w-5 h-5' />,
        label: 'Web Topup',
        to: '/payment-method-webtopup',
        subs: [],
        act: 'C,R,U,D',
      },
    ],
  },
  {
    id: 'setting-bank-deposit',
    label: 'Bank Deposit',
    to: '/setting-bank-deposit',
    subs: [],
    act: 'R,U',
    icon: <CogIcon className='w-5 h-5' />,
  },
  {
    id: 'mutasi-bank',
    icon: <ListBulletIcon className='w-5 h-5' />,
    label: 'Mutasi Bank Deposit',
    to: '/mutasi-bank',
    subs: [],
    act: 'R,U,E',
  },
];

export const PPOB = () => [
  {
    id: 'ppob-product',
    label: 'Produk',
    to: '/ppob-product',
    subs: [],
    act: 'C,R,U',
    icon: <WalletIcon className='w-5 h-5' />,
  },
  {
    id: 'ppob-product-category',
    label: 'Kategori Produk',
    to: '/ppob-product-category',
    subs: [],
    act: 'C,R,U',
    icon: <WalletIcon className='w-5 h-5' />,
  },
  {
    id: 'ppob-vendor',
    icon: <UsersIcon className='w-5 h-5' />,
    label: 'Vendor',
    to: '/ppob-vendor',
    subs: [],
    act: 'C,R,U',
  },
  {
    id: 'ppob-product-vendor',
    label: 'Produk Vendor',
    to: '/product-vendor',
    subs: [],
    act: 'C,R,U,D,I',
    icon: <WalletIcon className='w-5 h-5' />,
  },
  {
    id: 'product-voucher',
    icon: <TicketIcon className='w-5 h-5' />,
    label: 'Voucher',
    subs: [
      {
        id: 'product-voucher-product',
        label: 'Produk',
        to: '/product-voucher-product',
        subs: [],
        act: 'C,R,U,D',
        icon: <TicketIcon className='w-5 h-5' />,
      },
      {
        id: 'product-voucher-list-voucher',
        label: 'Stok',
        to: '/product-voucher-list-voucher',
        subs: [],
        act: 'C,R,U,I',
        icon: <TicketIcon className='w-5 h-5' />,
      },
      {
        id: 'product-voucher-category',
        label: 'Kategori',
        to: '/product-voucher-category',
        subs: [],
        act: 'C,R,U,D',
        icon: <TicketIcon className='w-5 h-5' />,
      },
      {
        id: 'ppob-voucher-label',
        label: 'Label',
        to: '/voucher-label',
        subs: [],
        act: 'C,R,U,D',
        icon: <TicketIcon className='w-5 h-5' />,
      },
    ],
  },
  {
    id: 'product-inject',
    icon: <TicketIcon className='w-5 h-5' />,
    label: 'Inject',
    subs: [
      {
        id: 'product-inject-category',
        label: 'Kategori',
        to: '/product-inject-category',
        subs: [],
        act: 'C,R,U,D',
        icon: <TicketIcon className='w-5 h-5' />,
      },
      {
        id: 'ppob-inject-label',
        label: 'Label',
        to: '/inject-label',
        subs: [],
        act: 'C,R,U,D',
        icon: <TicketIcon className='w-5 h-5' />,
      },
      {
        id: 'product-inject-whitelist-sn',
        label: 'Whitelist SN',
        to: '/product-inject-whitelist-sn',
        subs: [],
        act: 'R,I',
        icon: <TicketIcon className='w-5 h-5' />,
      },
    ],
  },
  {
    id: 'product-paket-data',
    icon: <TicketIcon className='w-5 h-5' />,
    label: 'Paket Data',
    subs: [
      {
        id: 'product-paket-data-category',
        label: 'Kategori',
        to: '/product-paket-data-category',
        subs: [],
        act: 'C,R,U,D',
        icon: <TicketIcon className='w-5 h-5' />,
      },
      {
        id: 'data-package-label',
        label: 'Label',
        to: '/data-package-label',
        subs: [],
        act: 'C,R,U,D',
        icon: <TicketIcon className='w-5 h-5' />,
      },
    ],
  },
  {
    id: 'digipos',
    icon: <ShoppingBagIcon className='w-5 h-5' />,
    label: 'Digipos',
    subs: [
      {
        id: 'digipos-account',
        label: 'Akun',
        to: '/digipos-account',
        subs: [],
        act: 'C,R,U,D',
        icon: <ShoppingBagIcon className='w-5 h-5' />,
      },
      {
        id: 'digipos-area',
        label: 'Area',
        to: '/digipos-area',
        subs: [],
        act: 'C,R,U,D',
        icon: <ShoppingBagIcon className='w-5 h-5' />,
      },
      {
        id: 'digipos-margin',
        label: 'Margin',
        to: '/digipos-margin',
        subs: [],
        act: 'C,R,U,D',
        icon: <ShoppingBagIcon className='w-5 h-5' />,
      },
    ],
  },
  {
    id: 'isimple',
    icon: <SparklesIcon className='w-5 h-5' />,
    label: 'Isimpel',
    subs: [
      {
        id: 'isimple-account',
        label: 'Akun',
        to: '/isimple-account',
        subs: [],
        act: 'C,R,U,D',
        icon: <SparklesIcon className='w-5 h-5' />,
      },
      {
        id: 'ismple-area',
        label: 'Area',
        to: '/isimple-area',
        subs: [],
        act: 'C,R,U,D',
        icon: <SparklesIcon className='w-5 h-5' />,
      },
      {
        id: 'isimple-margin',
        label: 'Margin',
        to: '/isimple-margin',
        subs: [],
        act: 'C,R,U,D',
        icon: <SparklesIcon className='w-5 h-5' />,
      },
    ],
  },
  {
    id: 'cuanku',
    icon: <CurrencyDollarIcon className='w-5 h-5' />,
    label: 'Cuanku',
    subs: [
      {
        id: 'cuanku-account',
        label: 'Akun',
        to: '/cuanku-account',
        subs: [],
        act: 'C,R,U,D',
        icon: <CurrencyDollarIcon className='w-5 h-5' />,
      },
      {
        id: 'cuanku-area',
        label: 'Area',
        to: '/cuanku-area',
        subs: [],
        act: 'C,R,U,D',
        icon: <CurrencyDollarIcon className='w-5 h-5' />,
      },
      {
        id: 'cuanku-margin',
        label: 'Margin',
        to: '/cuanku-margin',
        subs: [],
        act: 'C,R,U,D',
        icon: <CurrencyDollarIcon className='w-5 h-5' />,
      },
    ],
  },
  {
    id: 'markup',
    icon: <ArrowTrendingUpIcon className='w-5 h-5' />,
    label: 'Markup',
    subs: [
      {
        id: 'setting-markup-global',
        label: 'Global',
        to: '/setting-markup-global',
        subs: [],
        act: 'C,R,U,D',
        icon: <ArrowTrendingUpIcon className='w-5 h-5' />,
      },
      {
        id: 'setting-mark-up',
        label: 'Transfer Uang',
        to: '/setting-mark-up',
        subs: [],
        act: 'C,R,U,D',
        icon: <ArrowTrendingUpIcon className='w-5 h-5' />,
      },
    ],
  },
  {
    id: 'emoney-margin',
    label: 'Margin E-money',
    to: '/emoney-setting-margin',
    subs: [],
    act: 'C,R,D',
    icon: <Cog6ToothIcon className='w-5 h-5' />,
  },
  {
    id: 'money-transfer-bank',
    icon: <BanknotesIcon className='w-5 h-5' />,
    label: 'Bank Transfer',
    to: '/money-transfer-bank',
    subs: [],
    act: 'C,R,U,D,I,E',
  },
];

export const Konten = () => [
  {
    id: 'content-banner',
    icon: <WindowIcon className='w-5 h-5' />,
    label: 'Banner',
    to: '/content-banner',
    subs: [],
    act: 'C,R,U',
  },
  {
    id: 'content-blog',
    label: 'Blog',
    to: '/content-blog',
    subs: [],
    act: 'C,R,U',
    icon: <PlayIcon className='w-5 h-5' />,
  },
  {
    id: 'content-category',
    label: 'Kategori Blog',
    to: '/content-category',
    subs: [],
    act: 'C,R,U',
    icon: <PlayIcon className='w-5 h-5' />,
  },
  {
    id: 'content-video',
    icon: <VideoCameraIcon className='w-5 h-5' />,
    label: 'Video',
    to: '/content-video',
    subs: [],
    act: 'C,R,U,D',
  },
  {
    id: 'content-tutorial',
    icon: <PlayIcon className='w-5 h-5' />,
    label: 'Tutorial',
    to: '/content-tutorial',
    subs: [],
    act: 'C,R,U,D',
  },
  {
    id: 'static-content',
    icon: <PlayIcon className='w-5 h-5' />,
    label: 'Konten Statis',
    to: '/static-content',
    subs: [],
    act: 'C,R,U',
  },
  {
    id: 'content-slider',
    icon: <PhotoIcon className='w-5 h-5' />,
    label: 'Slider',
    subs: [
      {
        id: 'content-slider',
        label: 'Website',
        to: '/content-slider',
        subs: [],
        act: 'C,R,U',
        icon: <PhotoIcon className='w-5 h-5' />,
      },
      {
        id: 'content-slider-app',
        label: 'Aplikasi',
        to: '/content-slider-app',
        subs: [],
        act: 'C,R,U',
        icon: <PhotoIcon className='w-5 h-5' />,
      },
    ],
  },
];

export const Report = () => [
  {
    id: 'report-customer',
    icon: <UserGroupIcon className='w-5 h-5' />,
    label: 'Customer',
    subs: [
      {
        id: 'report-customer-deposit-saldo',
        label: 'Saldo',
        to: '/report-customer-deposit-saldo',
        subs: [],
        act: 'R',
        icon: <UserGroupIcon className='w-5 h-5' />,
      },
      {
        id: 'report-deposit',
        label: 'Deposit',
        to: '/report-deposit',
        subs: [],
        act: 'R,E',
        icon: <UserGroupIcon className='w-5 h-5' />,
      },
      {
        id: 'report-mutasi-saldo',
        label: 'Mutasi Saldo',
        to: '/report-mutasi-saldo',
        subs: [],
        act: 'R,E',
        icon: <UserGroupIcon className='w-5 h-5' />,
      },
      {
        id: 'report-registrasi-customer',
        label: 'Registrasi',
        to: '/report-registrasi-customer',
        subs: [],
        act: 'R,E',
        icon: <UserGroupIcon className='w-5 h-5' />,
      },
      {
        id: 'report-customer-fraud',
        label: 'Fraud',
        to: '/report-customer-fraud',
        subs: [],
        act: 'R,E',
        icon: <UserGroupIcon className='w-5 h-5' />,
      },
      {
        id: 'report-customer-markup-company',
        label: 'Markup Company',
        to: '/report-customer-markup-company',
        subs: [],
        act: 'R',
        icon: <UserGroupIcon className='w-5 h-5' />,
      },
      {
        id: 'report-customer-markup',
        label: 'Markup Personal',
        to: '/report-customer-markup',
        subs: [],
        act: 'R',
        icon: <UserGroupIcon className='w-5 h-5' />,
      },
      {
        id: 'report-customer-program',
        label: 'Program',
        to: '/report-customer-program',
        subs: [],
        act: 'R,U,E',
        icon: <UserGroupIcon className='w-5 h-5' />,
      },
      {
        id: 'report-customer-qris',
        label: 'QRIS',
        to: '/report-customer-qris',
        subs: [],
        act: 'R',
        icon: <UserGroupIcon className='w-5 h-5' />,
      },
    ],
  },
  {
    id: 'report-transaksi',
    icon: <UserGroupIcon className='w-5 h-5' />,
    label: 'Transaksi',
    subs: [
      {
        id: 'report-ppob-transaction',
        label: 'PPOB',
        to: '/report-ppob-transaction',
        subs: [],
        act: 'R,E',
        icon: <UserGroupIcon className='w-5 h-5' />,
      },
      {
        id: 'report-webtopup-transaction',
        label: 'Web Topup',
        to: '/report-webtopup-transaction',
        subs: [],
        act: 'R,E',
        icon: <UserGroupIcon className='w-5 h-5' />,
      },
      {
        id: 'report-app-transaction',
        label: 'Aplikasi',
        to: '/report-app-transaction',
        subs: [],
        act: 'R,E',
        icon: <UserGroupIcon className='w-5 h-5' />,
      },
      {
        id: 'report-ppob-pending-time',
        label: 'Waktu Pending',
        to: '/report-ppob-pending-time',
        subs: [],
        act: 'R',
        icon: <UserGroupIcon className='w-5 h-5' />,
      },
      {
        id: 'report-idpel-emoney',
        label: 'ID Pelanggan E-money',
        to: '/report-idpel-emoney',
        subs: [],
        act: 'R',
        icon: <UserGroupIcon className='w-5 h-5' />,
      },
      {
        id: 'report-group-tfsaldo',
        label: 'ID Pelanggan Transfer Saldo',
        to: '/trx-group-tfsaldo',
        subs: [],
        act: 'R',
        icon: <UserGroupIcon className='w-5 h-5' />,
      },
      {
        id: 'report-idpel-tfbank',
        label: 'ID Pelanggan Transfer Bank',
        to: '/report-idpel-tfbank',
        subs: [],
        act: 'R',
        icon: <UserGroupIcon className='w-5 h-5' />,
      },
    ],
  },
  {
    id: 'report-omset',
    icon: <UserGroupIcon className='w-5 h-5' />,
    label: 'Omzet',
    subs: [
      {
        id: 'report-customer-omset',
        label: 'Customer',
        to: '/report-customer-omset',
        subs: [],
        act: 'R,E',
        icon: <UserGroupIcon className='w-5 h-5' />,
      },
      {
        id: 'report-omset-product',
        label: 'Produk',
        to: '/report-omset-product',
        subs: [],
        act: 'R,E',
        icon: <UserGroupIcon className='w-5 h-5' />,
      },
    ],
  },
  {
    id: 'report-komisi-spv',
    label: 'Komisi SPV',
    to: '/report-komisi-spv',
    subs: [],
    act: 'R',
    icon: <UserGroupIcon className='w-5 h-5' />,
  },
  {
    id: 'report-ppob-sale',
    icon: <ExclamationTriangleIcon className='w-5 h-5' />,
    label: 'Penjualan Master',
    to: '/report-ppob-sale',
    subs: [],
    act: 'R',
  },
  {
    id: 'report-performa-outlet',
    icon: <ViewColumnsIcon className='w-5 h-5' />,
    label: 'Performa Outlet',
    to: '/report-performa-outlet',
    subs: [],
    act: 'R',
  },
  {
    id: 'report-customer-emoney',
    icon: <CurrencyDollarIcon className='w-5 h-5' />,
    label: 'Top Customer per Kategori',
    to: '/report-customer-emoney',
    subs: [],
    act: 'R',
  },
  {
    id: 'report-laba-rugi-ppob',
    icon: <ViewColumnsIcon className='w-5 h-5' />,
    label: 'Laba/Rugi PPOB',
    to: '/report-laba-rugi-ppob',
    subs: [],
    act: 'R,E',
  },
  {
    id: 'report-input-voucher-admin',
    icon: <ExclamationTriangleIcon className='w-5 h-5' />,
    label: 'Input Voucher Admin',
    to: '/report-input-voucher-admin',
    subs: [],
    act: 'R',
  },
  {
    id: 'export-tagihan',
    icon: <ArrowUpOnSquareStackIcon className='w-5 h-5' />,
    label: 'Tagihan PIC',
    to: '/export-tagihan',
    subs: [],
    act: 'R,E',
  },
];

export const Pengaturan = () => [
  {
    id: 'prefix-provider',
    icon: <DevicePhoneMobileIcon className='w-5 h-5' />,
    label: 'Prefix Provider',
    to: '/prefix-provider',
    subs: [],
    act: 'C,R,U,D',
  },
  {
    id: 'setting-general',
    icon: <ViewColumnsIcon className='w-5 h-5' />,
    label: 'Umum',
    to: '/setting-general',
    subs: [],
    act: 'R,U',
  },
  {
    id: 'user',
    icon: <UsersIcon className='w-5 h-5' />,
    to: '/user',
    label: 'Admin',
    subs: [],
    act: 'C,R,U,D',
  },
  {
    id: 'device-user',
    icon: <DevicePhoneMobileIcon className='w-5 h-5' />,
    label: 'Perangkat',
    to: '/device-user',
    subs: [],
    act: 'C,R,U,D',
  },
  {
    id: 'user-permissions',
    icon: <KeyIcon className='w-5 h-5' />,
    label: 'Hak Akses',
    to: '/user-permissions',
    subs: [],
    act: 'C,R,U,D',
  },
  {
    id: 'settings-blacklist',
    icon: <Cog6ToothIcon className='w-5 h-5' />,
    label: 'Blacklist',
    subs: [
      {
        id: 'blacklist-customer',
        icon: <NoSymbolIcon className='w-5 h-5' />,
        label: 'ID Pelanggan',
        to: '/blacklist-customer',
        subs: [],
        act: 'C,R,U,D',
      },
      {
        id: 'blacklist-ip',
        icon: <NoSymbolIcon className='w-5 h-5' />,
        label: 'IP',
        to: '/blacklist-ip',
        subs: [],
        act: 'C,R,U,D',
      },
    ],
  },
  {
    id: 'monitoring-otp',
    icon: <KeyIcon className='w-5 h-5' />,
    label: 'Monitoring OTP',
    to: '/monitoring-otp',
    subs: [],
    act: 'R',
  },
  {
    id: 'settings-limit',
    icon: <Cog6ToothIcon className='w-5 h-5' />,
    label: 'Limit',
    subs: [
      {
        id: 'setting-block-limit',
        icon: <CogIcon className='w-5 h-5' />,
        label: 'Batasan Blokir',
        to: '/setting-block-limit',
        subs: [],
        act: 'R,U',
      },
      {
        id: 'setting-rekomendasi-limit',
        icon: <CogIcon className='w-5 h-5' />,
        label: 'Rekomendasi',
        to: '/setting-rekomenasi-limit',
        subs: [],
        act: 'R,C,D',
      },
      {
        id: 'limit-bypass-emoney',
        label: 'Bypass E-money',
        to: '/limit-bypass-emoney',
        subs: [],
        act: 'C,R,D',
        icon: <Cog6ToothIcon className='w-5 h-5' />,
      },
    ],
  },
];

// Keep the sidebar, permission picker, and menu preview in the same order.
export const buildMenuGroups = (unread = {}) => [
  { title: 'Dashboard', items: Dashboard() },
  { title: 'Member', items: Member() },
  { title: 'Customer Service', items: CustomerService(unread) },
  { title: 'Transaksi', items: PPOB_Trx() },
  { title: 'E-Wallet', items: Wallet() },
  { title: 'PPOB', items: PPOB() },
  { title: 'Konten', items: Konten() },
  { title: 'Laporan', items: Report() },
  { title: 'Pengaturan', items: Pengaturan() },
];
